import React, { useEffect, useState } from 'react';
import './tooltip.css';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';

export default function List({ PopupID = "", setIsEdit, setEditId }) {
    const store_data = JSON.parse(store());
    const [SMTP, setSMTP] = useState([]);

    // Permission states
    const [canView, setCanView] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [canToggleStatus, setCanToggleStatus] = useState(false);
    const [canTest, setCanTest] = useState(false);

    const handleCopyClipboard = text => {
        // console.log(text)
        navigator.clipboard.writeText(text)
    }

    const fetchSMTPCreds = async () => {
        const filter = { org_id: store_data?.org_id }
        const response = await postAPI("/smtp/list", { ...filter, user: store_data });
        if (response?.status == 1) {
            setSMTP(response?.data);
        } else {
            setSMTP([]);
        }
        console.log(response)
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanCreate(true);
                setCanEdit(true);
                setCanDelete(true);
                setCanToggleStatus(true);
                setCanTest(true);
                fetchSMTPCreds();
            } else {
                const viewAllowed = await hasPermission("SETTINGS", "SMTPSMS", "VIEW");
                const createAllowed = await hasPermission("SETTINGS", "SMTPSMS", "CREATE");
                const editAllowed = await hasPermission("SETTINGS", "SMTPSMS", "EDIT");
                const deleteAllowed = await hasPermission("SETTINGS", "SMTPSMS", "DELETE");
                const toggleAllowed = await hasPermission("SETTINGS", "SMTPSMS", "TOGGLESTATUS");
                const testAllowed = await hasPermission("SETTINGS", "SMTPSMS", "TEST");

                setCanView(viewAllowed);
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
                setCanDelete(deleteAllowed);
                setCanToggleStatus(toggleAllowed);
                setCanTest(testAllowed);

                if (viewAllowed) {
                    fetchSMTPCreds();
                }
            }
        };
        checkPermissions();
    }, [])

    const handleChangeStatus = async (id, status) => {
        if (!canToggleStatus) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id, status: status }
        const response = await postAPI("/smtp/toggle-status", { ...filter, user: store_data });
        if (response?.status == 1) {
            toast.success('Status Changed Successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const handleRemove = async id => {
        if (!canDelete) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id }
        const response = await postAPI("/smtp/remove", { ...filter, user: store_data });
        if (response?.status == 1) {
            toast.success('SMTP Credential Removed Successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    return (
        <>
            <ToastContainer />
            <table class="table card-table">
                <thead>
                    <tr>
                        <th>Host</th>
                        <th>Port</th>
                        <th>Username</th>
                        <th>Password</th>
                        <th style={{ width: '100px' }}>Status</th>
                        <th style={{ width: '160px' }}>Actions</th>
                    </tr>
                </thead>
                <tbody class="table-border-bottom-0">
                    {
                        !canView ? (
                            <tr>
                                <td colSpan="6" className="text-center text-danger py-4">
                                    You do not have permission to view this page.
                                </td>
                            </tr>
                        ) : SMTP && SMTP?.length > 0 ?
                            SMTP?.map((val, index) => (
                                <tr>
                                    <td>{val?.host}</td>
                                    <td>{val?.port}</td>
                                    <td>{val?.username}</td>
                                    {/* <td>{val?.password}</td> */}
                                    <td>
                                        <span className="custom-tooltip"> ******** &nbsp; &nbsp;
                                            <span className="badge bg-label-primary me-1" onClick={() => handleCopyClipboard(val?.password)}><i className="fa-regular fa-copy"></i></span>
                                            <span className="tooltip-text">Copy Password</span>
                                        </span>
                                    </td>
                                    <td>
                                        <span className={`badge ${val?.status === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1 cursor-pointer custom-tooltip`} onClick={() => handleChangeStatus(val?.id, !val?.status)}>
                                            {val?.status === 1 ? 'Active' : 'Inactive'}
                                            <span className="tooltip-text">Toggle Status</span>
                                        </span>
                                    </td>
                                    <td>
                                        {/* <span className="badge bg-label-primary me-1"><i className="fa-regular fa-eye"></i></span> */}
                                        <span className="badge bg-label-primary me-1 custom-tooltip" data-bs-toggle="modal" data-bs-target={`#${PopupID}`} onClick={() => { setIsEdit(true); setEditId(val?.id); }}>
                                            <i className="fa fa-pen"></i>
                                            <span className="tooltip-text">Edit SMTP</span>
                                        </span>
                                        <span className="badge bg-label-danger me-1 cursor-pointer custom-tooltip"
                                            onClick={() => {
                                                if (window.confirm("Are you sure? This action will permanently remove this data!")) {
                                                    handleRemove(val?.id);
                                                } else {
                                                    console.log("Remove cancelled.");
                                                }
                                            }}
                                        >
                                            <i className="fa fa-trash"></i>
                                            <span className="tooltip-text">Delete SMTP</span>
                                        </span>
                                    </td>
                                </tr>
                            ))
                            : ""
                    }
                </tbody>
            </table>
        </>
    )
}
